import { formatDayLabel } from '@/shared/lib';

export interface ChatDayDividerProps {
  dayKey: string | null;
}

export function ChatDayDivider({ dayKey }: ChatDayDividerProps) {
  const label = formatDayLabel(dayKey);

  return (
    <div
      aria-label={label}
      className="flex items-center gap-3 px-2 py-4 text-xs font-medium text-foreground"
    >
      <div className="h-px flex-1 bg-border" />
      <span>{label}</span>
      <div className="h-px flex-1 bg-border" />
    </div>
  );
}
